import React from 'react';
import { TextField, InputAdornment, Tooltip } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';

const FullWidthFilter = (props) => {
  const {columnDef} = props;
  return (
    <TextField
      style={columnDef.type === "numeric" ? { float: "right", width: "100%", fontSize: "0.8rem" } : {width: "100%", fontSize: "0.8rem"}}
      type={columnDef.type === "numeric" ? "number" : "search"}
      value={columnDef.tableData.filterValue ? columnDef.tableData.filterValue.toUpperCase() : ""}
      placeholder={columnDef.placeholder}
      fullWidth={true}
      onChange={(event) => {
        props.onFilterChanged(
          columnDef.tableData.id,
          event.target.value
        );
      }}
      inputProps={{ "aria-label": `filter data by ${columnDef.title}`, style: columnDef.filterCellStyle }}
      InputProps={
        columnDef.hideFilterIcon
          ? undefined
          : {
              startAdornment: (
                <InputAdornment  position="start">
                  <Tooltip title="Filter">
                      <FilterList className="filterIcon"/>
                  </Tooltip>
                </InputAdornment>
              ),
            }
      }
    />
  );
};

export {
  FullWidthFilter
}
